import React, { useContext } from 'react';
import { GetDataContext } from '../../context/GetDataContext';
import { config_lineChartEV } from '../../models/diagramsConfig';
import partiesV2 from '../../models/partiesV2';


const AvgPartiesTable = () => {

    //App Configuration Options
    const {appConfigOptions,dataHandlingDone} = useContext(GetDataContext);
    const { partyTrendSensitivity} = appConfigOptions;

    let partiesTrend = [];
    let lastDate = "";

    partiesV2.forEach( (party) => {
        if (party.id < 9) {
            partiesTrend.push({
                partyName: party.label,
                partyTrend: "",
                lastMAValue: 0,
            });
        } else return
        // else if (party.id === 7 ) {
        //     partiesTrend.push({
        //         partyName: "ΑΛΛΟ",
        //         partyTrend: "",
        //         lastMAValue: 0,
        //     });
        // }

    });

    //Number Decimals Precision
    const Precision = (value, digits) => {
        let precisedNumber = (Math.round(value * 100) / 100).toFixed(digits);
        return precisedNumber;
    }

    partiesV2.forEach(( party, index ) => {
        if(index < partiesV2.length - 3){
            let length= config_lineChartEV.series[2*index+1]?.data?.length;
            partiesTrend[index].lastMAValue = config_lineChartEV.series[2*index+1]?.data[length-1][1];
            let partyTrend = partiesTrend[index].lastMAValue - config_lineChartEV.series[2*index+1]?.data[length-2][1];
            if(partyTrend > partyTrendSensitivity) {
                partiesTrend[index].partyTrend = require("../../assets/images/arrow-up.png").default;
            }
            else if(partyTrend < -partyTrendSensitivity){
                partiesTrend[index].partyTrend = require("../../assets/images/arrow-down.png").default;
            } else {
                partiesTrend[index].partyClass = "stable";
                partiesTrend[index].partyTrend = require("../../assets/images/dash-indicator.png").default;
            }
        }});
        lastDate = partiesV2[0].data.evaluation.lastDate;

    return (
        <section className={'container container--parties-average'}>
            <h2>Μέση Εκτίμηση Ψήφου από όλες τις εταιρίες* (%) </h2>
            <ul className={'reset list--parties'}>
                {partiesTrend.map(
                    (party,index) => <li key={index} className={'list--parties__item'}><h3>{party.partyName}</h3><div className={partiesTrend[index].partyClass && dataHandlingDone ? `party__trend ${partiesTrend[index].partyClass}` : "party__trend"}><span>{Precision(party.lastMAValue, 1)}</span>{partiesTrend[index].partyTrend && dataHandlingDone ? <figure><img src={partiesTrend[index].partyTrend} className="parties-trend__logo" alt="Party Trend"/></figure> : <div className='parties-trend__logo parties-trend__placeholder'></div>}</div></li>
                )}
            </ul>
            <p className={'container--parties-average__info'}>
                <span className={'info--text'}><sup>*</sup>Η εκτίμηση ψήφου προκύπτει σύμφωνα με το moving average των τελευταίων 10 δημοσκοπήσεων</span>
                <span className={'info--published-date'}>Τελευταία ενημέρωση: <time dateTime={lastDate}>{lastDate}</time></span>
            </p>
        </section>
    );
};

export default AvgPartiesTable;
